import React from "react";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { FolderIcon } from "@common/folderIcon";
import { ZoneAvatar } from "@common/zoneAvatar";

import { sanitize } from "../utils";
import { Props } from "./types";
import { Icon } from "./icon";
import { AllocationsList } from "./allocationsList";
import { Status } from "./status";
import styles from "./styles.scss";

function Task({ query, args }: Props) {
  const { pushView } = useModal();

  return (
    <div
      className={styles.task}
      onClick={() =>
        pushView({
          key: UseCases.retrieveTask,
          data: { task: args, isMultiProject: true },
        })
      }
    >
      <Icon className={styles.icon} />
      <div className={styles.main}>
        <div className={styles.header}>
          <p
            className={styles.name}
            dangerouslySetInnerHTML={{
              __html: args.name.replace(
                new RegExp(sanitize(query.name), "ig"),
                `<span class="${styles.match}">${query.name}</span>`,
              ),
            }}
          />
          <div className={styles.allocations}>
            <AllocationsList allocations={args.allocations} />
          </div>
        </div>
        <div className={styles.footer}>
          <div>
            <div className={styles.status}>
              <Status status={args.status} />
            </div>
          </div>
          <div>
            <div className={styles.zone}>
              <ZoneAvatar {...args.zone} />
            </div>
          </div>
          <div>
            <div className={styles.project}>
              <FolderIcon className={styles.projectIcon} />
              <p className={styles.projectName}>{args.project.name}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Task };
